import React from 'react';
import {connect} from 'react-redux';
import compose from 'recompose/compose';
import setDisplayName from 'recompose/setDisplayName';
import ImageEditModal from "components/images/ImageEditModal";
import {
    endEditImageAction,
    saveImageDataAction,
    changeImageSelectionAction,
    startEditImageAction
} from "./actions";

const mapStateToProps = (state) => {
    const selectedImage = state.images.selectedPendingImage || state.resources.resources[state.images.selectedImageId];

    const currentEditBreakId = state.editBreak.break ? state.editBreak.break[state.editBreak.currentPlatform] : null;
    const currentEditBreak = currentEditBreakId ? state.resources.resources[currentEditBreakId] : null;

    if (selectedImage && currentEditBreak) {
        selectedImage.sponsoredType = currentEditBreak.sponsoredType;
    }

    const siblingImages = state.images.selectedImageSiblings.map(id => state.resources.resources[id]);

    return {
        data: selectedImage,
        isOpen: state.images.editingImage,
        selectedImageSiblings: siblingImages
    };
};

const mapDispatchToProps = (dispatch) => ({
    onClose: () => dispatch(endEditImageAction()),
    siblingClicked: (imageId) => dispatch(startEditImageAction(imageId)),
    onSaveData: (data) => {
        dispatch(data ? saveImageDataAction(data) : endEditImageAction());
    }
});

export default compose(
    setDisplayName('ImageEditModalContainer'),
    connect(mapStateToProps, mapDispatchToProps)
)(ImageEditModal);



// WEBPACK FOOTER //
// ./public/pages/Images/ImageEditModalContainer.jsx